import React from 'react'
import { Route, Link, BrowserRouter as Router, Switch, Redirect } from 'react-router-dom'
import sdk from "matrix-js-sdk"
import jMoment from 'moment-jalaali'
import style from 'style/user-list.css'
import RoomListItem from 'components/chat/RoomListItem.js'
import BottomNavigation from 'components/BottomNavigation'
import Loading from 'components/Loading'
import Header from 'components/Header'
import Matrix from '../../scripts/Matrix'
import utils from '../../Utils';
import SnackBar from 'components/SnackBar'
import ConsultItemPatient from '../consult/ConsultItemPatient'
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import PhoneIcon from '@material-ui/icons/Phone'
import NavigateBeforeRoundedIcon from '@material-ui/icons/NavigateBeforeRounded';
import ModalSimpleMessage from 'components/ModalSimpleMessage'
import ConsultCategoryItem from '../consult/ConsultCategoryItem'
import history from '../../history';
import ModalAlert from '../ModalAlert'
import axios from 'axios'



class UserList extends React.Component {
  constructor(props) {
    super(props)
    const consultRequestId = this.props.location.state && this.props.location.state.consultId
    // console.log(this.props.location, '=============')
    const params = new URLSearchParams(history.location.search);
    // console.log('----------------ask status', params.get('status'))
    this.status = params.get('status')

    this.state = {
      isloadRoom: false,
      rooms: [],
      client: undefined,
      userId: undefined,
      accessToken: undefined,
      nextSyncToken: undefined,
      openModal: false,
      consults: [],
      assignedConsults: [],
      consultRequestId,
      redirect: '',
      categories: []
    }
  }

  getJalaiData() {
    let m;
    m = jMoment(this.state.startDate)
    return (m.jYear() + '/' + (m.jMonth() + 1) + '/' + m.jDate())
  }

  _getToken = async () => {
    await this.login()
    this.state.client.on('Room.timeline', this.onRoomTimeline);

  };

  onRoomTimeline = async (event, state, toStartOfTimeline) => {
    // console.log('clientclient', event, event.event.room_id)
    // console.log('clientclient', event)
    if (event.event.type === 'm.room.member' && event.event.membership === 'join' && event.event.sender === Matrix.getUserId()) {
      await this.apiAskedQuestion()
      await this.updateRooms()
      this.appendConsultInsideRoom()
    }
    if (event.event.type == 'm.room.message') {
      this.updateRooms()
    }
  }

  updateRooms = () => {
    // console.log('in rooms update---------')
    const roomList = this.state.client.getRooms();
    // console.log('roomList1', roomList)
    // console.log('roomList1', client)
    // console.log('rooooom', roomList[3].getUnreadNotificationCount())
    roomList.sort(function (a, b) {
      if (a.timeline.length > 0 && b.timeline.length > 0) {
        return b.timeline[b.timeline.length - 1].event.origin_server_ts - a.timeline[a.timeline.length - 1].event.origin_server_ts;
      }
    });
    this.setState({ rooms: roomList })
  }



  async login() {
    try {

      let _this = this;
      let client = await Matrix.login()

      // console.log('state', state)
      const roomList = client.getRooms();
      // console.log('roomList1', roomList)
      // console.log('roomList1', client)
      // console.log('rooooom', roomList[3].getUnreadNotificationCount())
      roomList.sort(function (a, b) {
        if (a.timeline.length > 0 && b.timeline.length > 0) {
          return b.timeline[b.timeline.length - 1].event.origin_server_ts - a.timeline[a.timeline.length - 1].event.origin_server_ts;
        }
      });
      // console.log('roomList', roomList)

      _this.setState({
        rooms: roomList,
        isloadRoom: true,
        refreshing: false,
        nextSyncToken: 'data.nextSyncToken',
      });
      // console.log('roomList', roomList);

      this.setState({
        client: client,

      });
    } catch (e) {
      console.log(e, ' login request result');
      // console.warn(e.message, ' login request result');
    }
  };

  createRoom = (questionText) => {
    if (this.state.roomName) {
      this.setState({ isLoading: true })

      fetch('http://dev.safarbe.com/api/create-room/', {
        method: 'POST',
        headers: {
          'Authorization': "Token " + this.state.token,
          'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'accept-language': 'fa'

        },
        body: 'topic=' + questionText
      })
        .then((response) => response.json())
        .then((responseJson) => {
          const jsonString = JSON.stringify(responseJson);
          this.setState({ isModalVisible: false, isLoading: false, openModal: false });
        })
        .catch((error) => {
          // Alert.alert("error_comment", "" + error);
        });
    }
  }

  apiAskedQuestion = async () => {
    let result = await utils.iaxios({
      method: 'post',
      url: utils.urls.PATIENT_CONSULT_REQUEST_URL,
      data: { status: ['asked', 'initiated', 'rejected', 'asigned', 'closed', 'reopen'] }
    }, true)
      // let result = await axios.post(utils.urls.PATIENT_CONSULT_REQUEST_URL, { status: 'asked' }, {
      //   headers: {
      //     'x-access-token': Matrix.getToken()
      //   }
      // })
      .catch((e) => {
        console.log(e.response)
        let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        this.SnackBar.openSnackbar(message)
      });
    // this.setState({ loading: false })

    if (!result) return
    // console.log(result, '###############')

    let { success, consults } = result.data;

    let notAssigned = consults.filter(consult => ['asked', 'initiated', 'rejected'].includes(consult.status))
    let assigned = consults.filter(consult => ['asigned', 'closed', 'reopen'].includes(consult.status))

    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
    this.setState({ consults: notAssigned, assignedConsults: assigned })
  }

  async componentDidMount() {
    if (this.state.consultRequestId)
      return this.setState({ redirect: { pathname: '/consult/new', state: { consultId: this.state.consultRequestId } } })
    if (this.status != null) {
      let msg = 'درخواست مشاوره با موفقیت ثبت شد'
      if (this.status == 1) {
        msg = 'در خواست مشاوره ثبت نشد'
      } else if (this.status == 0) {
        if (utils.getCookies().get('tatoken')) {
          utils.getCookies().remove('tatoken')
        }
      }
      window.history.pushState(null, null, '/chats')

      this.SnackBar.openSnackbar(msg, this.status == 0 ? 'info' : '')
    }
    await this._getToken();
    await this.apiAskedQuestion() // TODO: just patients must call this api
    // console.log(this.state.rooms)
    // if (sessionStorage.scrollTopChats) {
    //   setTimeout(() => { this.refs.roomsContainer.scrollTop = sessionStorage.scrollTopChats }, 300)
    // }

    this.appendConsultInsideRoom()

    if (!this.state.consults.length && !this.state.rooms.length)
      await this.apiGetAllConsultCategory()
  }

  appendConsultInsideRoom = () => {
    let complex = {}
    let array = []

    if (this.state.assignedConsults.length === 0) return

    this.state.assignedConsults.map(consult => complex[consult.roomId] = consult)

    this.state.rooms.map(room => {
      if (complex[room.roomId]) {
        array.push({
          consult: complex[room.roomId],
          ...room
        })
      } else {
        array.push({
          ...room
        })
      }
    })

    this.setState({ rooms: array })
  }

  handleScroll = (e) => {
    let element = e.target
    sessionStorage.scrollTopChats = element.scrollTop
  }

  onDeleteConsult = id => {
    var index = this.state.consults.findIndex(consult => consult.id === id)
    var consults = this.state.consults
    consults.splice(index, 1)
    this.setState({ consults });

    return this.SnackBar.openSnackbar('عملیات با موفقیت انجام شد', 'info')
  }

  apiDeleteConsult = async id => {
    let res = await axios.delete(utils.urls.consultRequsetWaitingForPayment(id), {
      headers: {
        'x-access-token': Matrix.getToken()
      }
    })
      .catch((e) => {
        console.log(e)
        let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        this.SnackBar.openSnackbar(message)
      });

    if (!res) return
    const { success } = res.data
    this.onDeleteConsult(id)
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
  }

  async gotoNewConsult() {
    console.log('tag manager', 'new consult clicked')
    utils.sendGtmEvent('Engage', 'New Request')
  }

  attachRooms() {
    let _this = this
    return (
      <div className="roomsContainer" onScroll={this.handleScroll}
        ref={(el) => { if (el && sessionStorage.scrollTopChats) { el.scrollTop = sessionStorage.scrollTopChats } }}>
        <Link to='/categories' style={{ backgroundColor: '#eee', paddingBottom: '25px', borderBottom: '1px solid #ddd', display: 'block', color: 'unset' }}>
          <div onClick={this.gotoNewConsult} style={{ background: '#fff', borderBottom: '1px solid #ddd', padding: '10px 15px', display: 'flex' }}>
            <AddRoundedIcon style={{ color: '#1dc37e' }}></AddRoundedIcon>
            <span style={{ flexGrow: 1 }}> درخواست مشاوره جدید</span>
            <NavigateBeforeRoundedIcon></NavigateBeforeRoundedIcon>
          </div>
        </Link>

        {/*<Link to='/calls' style={{ backgroundColor: '#eee', paddingBottom: '25px', borderBottom: '1px solid #ddd', display: 'block', color: 'unset' }}>
          <div style={{ background: '#fff', borderBottom: '1px solid #ddd', padding: '10px 15px', display: 'flex' }}>
            <PhoneIcon style={{ color: '#1dc37e' }} />
            <span style={{ flexGrow: 1 }}>مشاهده لیست تماس ها</span>
            <NavigateBeforeRoundedIcon></NavigateBeforeRoundedIcon>
          </div>
        </Link> */}
        {
          this.state.consults.map((consult, index) => {
            return (
              <ConsultItemPatient key={'consult' + consult.id} openModal={this.modalAlert.openModal} onDeleteConsult={this.onDeleteConsult} consult={consult} onRowClick={this.modalSimpleMessage.openModal}></ConsultItemPatient>
            )
          })
        }
        {
          this.state.rooms.map((room) => {
            // console.log(room.getJoinedMembers())
            return (
              <RoomListItem key={room.roomId} room={room} consult={room.consult} clientData={{
                client: this.state.client,
                userId: this.state.userId,
                accessToken: this.state.accessToken,
                nextSyncToken: this.state.nextSyncToken
              }} />
            )
          })
        }

        {!this.state.consults.length && !this.state.rooms.length && this.renderCategries()}
      </div>

    )
  }

  renderCategries = () =>
    <div style={{ paddingRight: '10px', paddingLeft: '10px', overflowY: 'auto', flexGrow: 1 }}>
      {this.state.categories.map(category =>
        <ConsultCategoryItem
          key={category.id}
          category={category}
        />)
      }
    </div>

  apiGetAllConsultCategory = async () => {
    this.setState({ isLoading: true })
    let result = await axios.get(utils.urls.consultCategories).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    });
    this.setState({ isLoading: false })

    if (!result) return
    // console.log(result, '###############')

    let { success, consultCategories } = result.data;
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
    this.setState({ categories: consultCategories })
  }

  componentWillUnmount() {
    if (this.state.client) this.state.client.removeListener('Room.timeline', this.onRoomTimeline)
  }

  render() {
    if (this.state.redirect)
      return <Redirect to={this.state.redirect} push ></Redirect>
    return (
      <React.Fragment>
        <Header title="طبینجا" showBackButton={false} desc='لیست مشاوره ها و درخواست ها' />
        <SnackBar ref={el => { this.SnackBar = el }}></SnackBar>
        <ModalAlert ref={el => this.modalAlert = el} action={data => this.apiDeleteConsult(data.id)} />

        <div className="messenger-room-root">
          {!this.state.isloadRoom && <Loading />}
          {this.state.isloadRoom && this.attachRooms()}
        </div>
        <BottomNavigation selected='2' />
        <ModalSimpleMessage ref={el => { this.modalSimpleMessage = el }} />
      </React.Fragment>
    )
  }
}

export default UserList
